import {
  ADMIN_PRICING_FETCH,
  ADMIN_PRICING_FETCH_SUCCESS,
  ADMIN_PRICING_FETCH_FAIL,
  ADMIN_PRICING_UPLOAD,
  ADMIN_PRICING_UPLOAD_SUCCESS,
  ADMIN_PRICING_UPLOAD_FAIL,
  ADMIN_PRICING_DELETE,
  ADMIN_PRICING_DELETE_SUCCESS,
  ADMIN_PRICING_DELETE_FAIL,
  ADMIN_PRICING_SET_SORT,
  ADMIN_PRICING_SET_PRICE,
  ADMIN_PRICING_SET_PRICE_FAIL
} from './constants';
import { createSelector } from 'reselect';

const initialState = {
  fetching: false,
  pricings: {},
  uploads: {},
  sortAttribute: 'name',
  sortAttributeInverted: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_PRICING_FETCH:
      return { ...state, fetching: true };
    case ADMIN_PRICING_FETCH_SUCCESS: {
      const pricings = {};
      action.pricings.forEach(pricing => {
        pricings[pricing.id] = pricing;
      });
      return { ...state, fetching: false, pricings };
    }
    case ADMIN_PRICING_FETCH_FAIL:
      return { ...state, fetching: false };
    case ADMIN_PRICING_UPLOAD: {
      const uploads = JSON.parse(JSON.stringify(state.uploads));
      const pricings = JSON.parse(JSON.stringify(state.pricings));
      uploads[action.pricing.id] = 'uploading';
      pricings[action.pricing.id] = action.pricing;
      return { ...state, uploads, pricings };
    }
    case ADMIN_PRICING_UPLOAD_SUCCESS: {
      const uploads = JSON.parse(JSON.stringify(state.uploads));
      delete uploads[action.pricing.id];
      return { ...state, uploads };
    }
    case ADMIN_PRICING_UPLOAD_FAIL: {
      const uploads = JSON.parse(JSON.stringify(state.uploads));
      uploads[action.pricing.id] = action.error;
      return { ...state, uploads };
    }
    case ADMIN_PRICING_DELETE: {
      const pricings = JSON.parse(JSON.stringify(state.pricings));
      delete pricings[action.pricing.id];
      return { ...state, pricings };
    }
    case ADMIN_PRICING_DELETE_SUCCESS:
      return state;
    case ADMIN_PRICING_DELETE_FAIL: {
      const pricings = JSON.parse(JSON.stringify(state.pricings));
      pricings[action.pricing.id] = action.pricing;
      return { ...state, pricings };
    }
    case ADMIN_PRICING_SET_SORT: {
      const sortAttributeInverted =
        state.sortAttribute === action.sort ?
          !state.sortAttributeInverted : false;
      return { ...state, sortAttribute: action.sort, sortAttributeInverted };
    }
    case ADMIN_PRICING_SET_PRICE: {
      const pricings = JSON.parse(JSON.stringify(state.pricings));
      pricings[action.pricingId].farmGatePrice = action.priceInPennies;
      return { ...state, pricings };
    }
    case ADMIN_PRICING_SET_PRICE_FAIL: {
      const pricings = JSON.parse(JSON.stringify(state.pricings));
      pricings[action.pricing.id] = action.pricing;
      return { ...state, pricings };
    }
  }
  return state;
};

const fetching = state => state.pricing.fetching;
const pricings = state => state.pricing.pricings;
const sortAttribute = state => state.pricing.sortAttribute;
const sortAttributeInverted = state => state.pricing.sortAttributeInverted;
const uploads = state => state.pricing.uploads;

export const fetchingPricings = createSelector(
  fetching, fetching => fetching
);

export const getPricingsObj = createSelector(
  pricings, pricings => pricings
);

export const getPricings = createSelector(
  pricings, pricings => {
    return Object.values(pricings);
  }
);

export const getLatestPricing = createSelector(
  pricings, pricings => {
    const itemsObj = JSON.parse(JSON.stringify(pricings));
    const items = Object.values(itemsObj);
    items.sort((a, b) => {
      if (a.date > b.date) return -1;
      if (a.date < b.date) return 1;
      return 0;
    });
    if (items.length > 0) return items[0];
    return null;
  }
);

export const getSortedPricings = createSelector(
  [getPricings, sortAttribute, sortAttributeInverted],
  (pricings, attribute, inverted) => {
    const items = JSON.parse(JSON.stringify(pricings));
    return items.sort((a, b) => {
      if (a[attribute] < b[attribute]) return inverted ? 1 : -1;
      if (a[attribute] > b[attribute]) return inverted ? -1 : 1;
      return 0;
    });
  }
);

export const getPricingsCount = createSelector(
  getPricings, pricings => pricings.length
);

export const getPricingsSortAttribute = createSelector(
  sortAttribute, sort => sort
);

export const getPricingsSortAttributeInverted = createSelector(
  sortAttributeInverted, inverted => inverted
);

export const getPricingUploadsObj = createSelector(
  uploads, uploads => uploads
);

export default reducer;
